import React from 'react';
import './Course.css';

function Course() {
  return (
    <div className="app-course w-full grid justify-items-center">
      <div className="section">
        <div className="grid max-sm:grid-rows-1 h-full md:h-full md:grid-cols-2 place-content-evenly md:gap-2">
          <div className="max-sm:hidden">
              <div className="app-course-bg h-[50vh] md:h-full w-full"></div>
          </div>

          <div id="curso" className="grid p-5 md:p-2 h-full w-full gap-2">
            <div className="text-sm md:text-xl">
                Curso DP
            </div>
            <div className="font-bold text-xl pt-3 pb-5">
                Explicamos a ciência por trás do aprendizado de idiomas e apresentamos técnicas desenvolvidas por poliglotas para aprender línguas 
            </div>
            
            <div className="grid grid-cols-6 place-content-around gap-2">
                <div className="md:text-5xl text-3xl text-orange-300 font-bold text-center">
                    01
                </div>
                <div className="text-xl font-bold col-span-5 md:col-span-2">
                    Ciência do aprendizado de idiomas
                  <div className="text-lg font-normal text-gray-400 pt-3">
                      Você conhecerá por que e como funciona nosso cérebro no aprendizado de idiomas
                  </div>
                </div>

                <div className="md:text-5xl text-3xl text-orange-300 font-bold text-center">
                    02
                </div>
                <div className="text-xl font-bold col-span-5 md:col-span-2">
                    Técnicas dos poliglotas
                  <div className="text-lg font-normal text-gray-400 pt-3">
                      Você será apresentado às técnicas desenvolvidas e utilizadas por poliglotas e superpoliglotas no aprendizado de idiomas
                  </div>
                </div>

                <div className="md:text-5xl text-3xl text-orange-300 font-bold text-center">
                    03
                </div>
                <div className="text-xl font-bold col-span-5 md:col-span-2">
                    Mapa de transformação individual
                  <div className="text-lg font-normal text-gray-400 pt-3">
                      Você terá a sua disposição o MTI, ferramenta exclusiva do DP, para controlar o seu processo
                  </div>
                </div>

                <div className="md:text-5xl text-3xl text-orange-300 font-bold text-center">
                    04
                </div>
                <div className="text-xl font-bold col-span-5 md:col-span-2">
                    Experiência do usuário
                  <div className="text-lg font-normal text-gray-400 pt-3">
                      Preparamos um módulo com a experiência do usuário para você saber como navegar por algumas das ferramentas mais uteis no aprendizado de idiomas
                  </div>
                </div>

                <div className="col-start-2 col-span-5 items-center justify-center pt-5">
                  <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                      hover:bg-gradient-to-br font-bold text-2xl rounded-4xl text-center w-3/4 cta">
                      <a href="https://hotmart.com/pt-br/marketplace/produtos/destino-poliglota/A99073686Q" target='_blank' rel='noopener noreferrer'>
                          Curso Destino Poliglota</a>
                  </button>
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Course;
